import type {GeocodingResponseType} from './GeocodingResponseType';
type LatLng = google.maps.LatLng;

/**
 * Performs a reverse geocoding request (address lookup) and returns the parsed result
 */
export const performReverseGeocode = (apiKey: string, coordinates: LatLng, language = 'en'):
  Promise<GeocodingResponseType> => new Promise((resolve, reject) => {
  let urlStr = 'https://maps.googleapis.com/maps/api/geocode/json'
  urlStr += `?latlng=${coordinates.lat()},${coordinates.lng()}`
  urlStr += `&key=${apiKey}`
  urlStr += `&language=${language}`

  return fetch(urlStr)
    .then(response => response.json())
    .then(json => resolve(json))
    .catch(err => reject(err))
})
